import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Links from '@/components/Links'
import Page from '@/components/Page'
import Music from '@/components/Music'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          component: Links
        },
        {
          path: '/page/:name',
          component: Page
        },
        {
          path: '/music',
          component: Music
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js